<template>
  <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
    <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
      <v-data-table :search="search" :headers="headers" :items="advancedrates?.commissionSetup || []"
        :items-per-page="7">
        <template v-slot:item.LevelView="{ item }">
          {{ `L1 - L${advancedrates?.total_ib_levels}` }}
        </template>
        <template v-slot:item.details="{ item }">
          <div class="d-flex align-center justify-center">
            <v-dialog transition="scale-transition" origin="center center" max-width="820" v-model="dialog[item?.id]"
              content-class="commission-tree">
              <template v-slot:activator="{ on, attrs }">
                <div class="links text-decoration-none mr-3">
                  <div @click="handleSplitCommission(item)" v-bind="attrs" v-on="on">
                    <v-icon color="#039de9" small>
                      mdi-pencil-outline
                    </v-icon>
                  </div>
                </div>
              </template>

              <v-stepper v-model="e1" class="password-stepper admin-password-stepper">
                <v-stepper-items>
                  <v-stepper-content step="1" class="pa-0">
                    <v-card class="deposit-form create-account-form" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'
                      ">
                      <v-row dense>
                        <v-card class="deposit-form create-account-form" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'
                          ">
                          <v-row dense>
                            <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark
                              ? 'blue-darken-1'
                              : 'white-lighten-5'
                              ">
                              <v-card-title class="pb-1 pt-0 justify-space-between font-weight-bold pl-3">
                                <span>View Commission Split</span>
                                <!-- <a target="_blank" class="text--green text-decoration-underline"
                                  href="https://www.youtube.com/watch?v=oRDRfikj2z8&t=1s">
                                  See Video
                                </a> -->
                              </v-card-title>
                              <v-card-subtitle class="mt-0 pl-3 pb-4 text--ash tree-commission-label">
                                <span>{{ item.account_type_display }}</span>
                                <span>{{ item.currency_group_title }}</span>
                                <span>L 1 - L{{ advancedratescomtree?.total_ib_levels || levelCounts }}</span>
                                <span>$ {{ item.commission_rate }}</span>
                              </v-card-subtitle>
                              <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark
                                ? 'blue-darken-1'
                                : 'white-lighten-5'
                                ">
                                <commission-split-table-2 :splitData="advancedratescomtree?.commissionRate"
                                  :levelCounts="Number(advancedratescomtree?.total_ib_levels || levelCounts)"
                                  :tutorial="advancedratescomtree?.tutorial" v-model="commissionRate"
                                  @update:splitData="updateSplitData"></commission-split-table-2>
                              </v-card>
                              <v-card-actions>
                                <v-row>

                                  <v-col cols="6">
                                    <v-btn @click="updateCommission(item)" :ripple="false" tile elevation="0"
                                      class="custom-btn px-10" color="#039de9" large>
                                      Update
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-card-actions>
                            </v-card>
                          </v-row>
                        </v-card>
                      </v-row>
                    </v-card>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-dialog>
          </div>
        </template>
      </v-data-table>
    </v-sheet>
  </v-card>
</template>

<script>
import { PARTNERLIST__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import CommissionSplitTable2 from './CommissionSplitTable2.vue';

export default {
  components: { CommissionSplitTable2 },
  props: {
    search: {
      type: String,
    },
    levelCounts: {
      type: Number,
    },
    advancedrates: {
      type: Array,
    },
  },
  data() {
    return {
      dialog: {},
      e1: 1,
      headers: [
        { text: "Account Type", value: "account_type_display", align: "start" },
        { text: "Group/Currency", value: "currency_group_title" },
        { text: "Level", value: "LevelView" },
        { text: "Total Commission", value: "commission_rate" },
      ],
    };
  },
  computed: {
    ...mapState("partnerlist", ["advancedratescomtree"]),
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    ...mapActions("partnerlist",
      [
        PARTNERLIST__ACTIONS.ADVANCEDRATESCOMMISSIONTREE,
        PARTNERLIST__ACTIONS.UPDATECOMMISSIONRATES,
      ]
    ),

    handleClose(item) {
      this.$set(this.dialog, item.id, false);
    },

    async handleSplitCommission(item) {
      await this[PARTNERLIST__ACTIONS.ADVANCEDRATESCOMMISSIONTREE]({
        partner_id: this.$route.query.id,
        account_type: item.account_type_id,
        currency_group: item.currency_group_id,
      })
    },

    updateSplitData(newData) {
      this.advancedratescomtree.commissionRate = { ...newData };
    },

    updateCommission(item) {
      this[PARTNERLIST__ACTIONS.UPDATECOMMISSIONRATES]({
        partner_id: this.$route.query.id,
        total_ib_levels: this.levelCounts,
        account_type: item.account_type_id,
        currency_group: item.currency_group_id,
        totalCommission: item.commission_rate,
        commissionRates: this.advancedratescomtree.commissionRate
      })
      this.handleClose(item)
    }
  },

  created(){
    if (this.$canRoute('commission-rates-partner-tab') === 1) {
      this.headers.push({ text: "Action", value: "details" });
    }
  }
};
</script>

<style>
.v-text-field{
  min-width: 60px !important;
}
</style>